export default __webpack_public_path__ + "static/media/Boundary of Death.155c3fef.png";